module.exports = __webpack_public_path__ + "media/images/pc/costumes/mv_shiromuku@3x-031184a6f2898f452a7295b34ad37792.webp";